(function () {
  const SECTION_HANDLES = ['header-group', 'header', 'cart-drawer']; // Prestige often uses header-group.json
  const SECTION_HOST_SELECTORS = {
    'header-group': '#shopify-section-header-group',
    header: '#shopify-section-header',
    'cart-drawer': '#shopify-section-cart-drawer',
  };

  async function fetchJSON(url, opts) {
    const res = await fetch(url, Object.assign({ credentials: 'same-origin' }, opts || {}));
    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/json')) return res.json();
    return res.text();
  }

  async function refreshPrestigeCartUI() {
    try {
      // Pull updated sections HTML
      const url = `${window.location.pathname}?sections=${SECTION_HANDLES.join(',')}`;
      const sections = await fetchJSON(url);

      SECTION_HANDLES.forEach((handle) => {
        const html = sections && sections[handle];
        if (!html) return;

        const host =
          document.querySelector(SECTION_HOST_SELECTORS[handle]) ||
          document.querySelector(`[id^="shopify-section-"][id*="${handle}"]`);

        if (host) host.innerHTML = html;
      });

      // Also broadcast cart updated events
      const cart = await fetchJSON('/cart.js');
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (e) {
      console.warn('[HYER] Failed to refresh cart UI:', e);
    }
  }

  // --- Hook fetch() to detect cart-changing calls ---
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await originalFetch.apply(this, args);

    try {
      const input = args[0];
      const url = typeof input === 'string' ? input : (input && input.url) ? input.url : '';
      const isCartMutation =
        url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear');

      if (isCartMutation) {
        // Wait a tick for Shopify to finish writing cart state, then refresh UI
        setTimeout(refreshPrestigeCartUI, 250);
      }
    } catch (_) {}

    return res;
  };

  // --- Hook XHR as well (some builders use XHR instead of fetch) ---
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__hyer_url = url;
    return originalOpen.call(this, method, url, ...rest);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      const url = this.__hyer_url || '';
      const isCartMutation =
        url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear');

      if (isCartMutation) {
        setTimeout(refreshPrestigeCartUI, 250);
      }
    });

    return originalSend.apply(this, args);
  };

  // Optional: run once on load to sync badge/drawer in case of stale state
  // setTimeout(refreshPrestigeCartUI, 500);
})();
